import {
  ALL_HUB_NAV_ITEMS,
  HUB_NAV_SECTIONS,
  createDefaultFlatNavVisibility,
} from '../config/hubNavItems.js';

/**
 * ハブ設定の表示マップでセクション／項目をフィルタする
 */
export function filterHubNavSections(sections, {
  visibilityMap,
  betaFeaturesRestricted,
  isHubSettingsReady = true,
}) {
  const visibility = visibilityMap || createDefaultFlatNavVisibility();
  return sections
    .map((section) => {
      let items = section.items.filter((item) => visibility[item.id] !== false);
      if (section.hideWhenBetaRestricted && betaFeaturesRestricted) {
        // 設定未読込中はサポート全体を隠す（legal だけ先出しのちらつき防止）
        // ready かつ β 中のみ keepWhenBetaRestricted（規約）を残す
        if (isHubSettingsReady === false) {
          items = [];
        } else {
          items = items.filter((item) => item.keepWhenBetaRestricted);
        }
      }
      return { ...section, items };
    })
    .filter((section) => section.items.length > 0);
}

/**
 * パスに対応するナビ項目を返す（完全一致優先、次に prefix）
 */
export function findNavItemByPath(pathname) {
  const path = String(pathname || '').split('?')[0];
  const exact = ALL_HUB_NAV_ITEMS.find((item) => item.path === path);
  if (exact) return exact;
  if (path === '/dashboard' || path === '/') {
    return ALL_HUB_NAV_ITEMS.find((item) => item.id === 'dashboard') || null;
  }
  const prefixed = ALL_HUB_NAV_ITEMS
    .filter((item) => item.path !== '/dashboard' && path.startsWith(item.path))
    .sort((a, b) => b.path.length - a.path.length);
  return prefixed[0] || null;
}

/**
 * 非表示時のフォールバック先パス
 */
export function resolveFallbackNavPath(visibilityMap) {
  const visibility = visibilityMap || createDefaultFlatNavVisibility();
  const preferredOrder = [
    'dashboard',
    'modules',
    'licenses',
    'account',
    'clinic',
    'users',
    'integrations',
    'billing',
    'contact',
    'invitation',
    'legal',
  ];
  for (const id of preferredOrder) {
    if (visibility[id] !== false) {
      const item = ALL_HUB_NAV_ITEMS.find((entry) => entry.id === id);
      if (item) return item.path;
    }
  }
  const firstVisible = ALL_HUB_NAV_ITEMS.find((item) => visibility[item.id] !== false);
  return firstVisible?.path || '/dashboard';
}

/**
 * 現在パスが非表示ナビならフォールバックへ誘導すべきか
 */
export function shouldRedirectHiddenNav(pathname, visibilityMap) {
  const item = findNavItemByPath(pathname);
  if (!item) return { redirect: false };
  const visibility = visibilityMap || createDefaultFlatNavVisibility();
  if (visibility[item.id] !== false) return { redirect: false };
  return {
    redirect: true,
    to: resolveFallbackNavPath(visibility),
  };
}

export { HUB_NAV_SECTIONS };
